import type { FC, PropsWithChildren, ReactElement } from 'react';

import { Modal } from '../modal/modal/index';

export interface SettingsModalProps extends PropsWithChildren {
  heightAdjustment?: number;
  isOpen: boolean;
  onClose: () => void;
  onBack?: () => void;
}

export const SettingsModal: FC<SettingsModalProps> = ({
  children,
  heightAdjustment,
  isOpen,
  onBack,
  onClose,
}): ReactElement => (
  <Modal
    data-testid="settings-modal"
    draggable
    fullScreenNoClose
    heightAdjustment={heightAdjustment}
    onBack={onBack}
    onClose={onClose}
    open={isOpen}
    placement="end"
    tk="SETTINGS"
  >
    {children}
  </Modal>
);
